import { createStore } from 'vuex'

export default createStore({
    state: {
        SIGN_KEY: '3wq5fc2fdhjsfnaene245441ekfjksa2dfja'
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
})
